function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualOwnershipBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.953 291.144H93.508c-13.177 0-23.86-10.683-23.86-23.86v-22.569c0-13.177 10.683-23.86 23.86-23.86h47.445c13.177 0 23.86 10.683 23.86 23.86v22.569c0 13.178-10.683 23.86-23.86 23.86z",
    style: {},
    fill: "#b6b6b6",
    "data-original": "#efcf4a",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.492 291.144h-47.445c-13.177 0-23.86-10.683-23.86-23.86v-22.569c0-13.177 10.683-23.86 23.86-23.86h47.445c13.177 0 23.86 10.683 23.86 23.86v22.569c0 13.178-10.683 23.86-23.86 23.86z",
    style: {},
    fill: "#b6b6b6",
    "data-original": "#60bec8",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.722 70.289h-47.445c-13.177 0-23.86-10.683-23.86-23.86V23.86C208.417 10.683 219.1 0 232.278 0h47.445c13.177 0 23.86 10.683 23.86 23.86v22.569c0 13.177-10.683 23.86-23.861 23.86z",
    style: {},
    fill: "#7f7a7a",
    "data-original": "#fc6947",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.567 512H24.124c-13.177 0-23.86-10.683-23.86-23.86v-22.569c0-13.177 10.683-23.86 23.86-23.86h47.445c13.177 0 23.86 10.683 23.86 23.86v22.569C95.428 501.317 84.745 512 71.567 512zM210.337 512h-47.445c-13.177 0-23.86-10.683-23.86-23.86v-22.569c0-13.177 10.683-23.86 23.86-23.86h47.445c13.177 0 23.86 10.683 23.86 23.86v22.569c0 13.177-10.682 23.86-23.86 23.86z",
    style: {},
    fill: "#b6b6b6",
    "data-original": "#efcf4a",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.107 512h-47.445c-13.177 0-23.86-10.683-23.86-23.86v-22.569c0-13.177 10.683-23.86 23.86-23.86h47.445c13.177 0 23.86 10.683 23.86 23.86v22.569c0 13.177-10.682 23.86-23.86 23.86zM487.876 512h-47.445c-13.177 0-23.86-10.683-23.86-23.86v-22.569c0-13.177 10.683-23.86 23.86-23.86h47.445c13.177 0 23.86 10.683 23.86 23.86v22.569c.001 13.177-10.681 23.86-23.86 23.86z",
    style: {},
    fill: "#b6b6b6",
    "data-original": "#60bec8",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.615 365.473h-61.548v-48.588a7.837 7.837 0 0 0-15.674 0v48.588H47.846a7.837 7.837 0 0 0-7.837 7.837v41.796a7.837 7.837 0 0 0 15.674 0v-33.959h123.096v33.959a7.837 7.837 0 0 0 15.674 0V373.31a7.839 7.839 0 0 0-7.838-7.837zM464.154 365.473h-61.548v-48.588a7.837 7.837 0 0 0-15.674 0v48.588h-61.548a7.837 7.837 0 0 0-7.837 7.837v41.796a7.837 7.837 0 0 0 15.674 0v-33.959h123.095v33.959a7.837 7.837 0 0 0 15.674 0V373.31a7.835 7.835 0 0 0-7.836-7.837zM386.933 196.059a7.837 7.837 0 0 0 15.674 0v-41.796a7.837 7.837 0 0 0-7.837-7.837H263.837V97.839a7.837 7.837 0 0 0-15.674 0v48.588H117.23a7.837 7.837 0 0 0-7.837 7.837v41.796a7.837 7.837 0 0 0 15.674 0V162.1h261.866v33.959z",
    style: {},
    fill: "#627384",
    "data-original": "#494f56",
    className: "",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualOwnershipBuilder);
export default __webpack_public_path__ + "static/media/visual-ownership-builder.bf2dcb8cdfec22ca85b9676b635eb0c0.svg";
export { ForwardRef as ReactComponent };